module.exports = __webpack_public_path__ + "static/img/knowledge_1.d69624d.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/service/knowledge_1.png
// module id = EIpm
// module chunks = 1